'use client';

import Image from 'next/image';

import Logo30Years from '../../../public/images/logo-30-years.svg';

export default function Banner() {
    return (
        <div className="relative h-[250px] md:h-[452px] xl:h-[550px]">
            <Image
                src="/images/campaigns/30years/bg-30-years.jpg"
                alt="Bioclinica 30 ani"
                className="absolute -z-10 object-cover"
                fill
                quality={100}
                sizes="100vw"
                priority
            />
            <div className="container mx-auto flex h-full flex-row items-center p-16 md:p-4">
                <Logo30Years className="mx-auto md:w-2/3 xl:w-2/5" />
            </div>
        </div>
    );
}
